import React from 'react';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import BackButton from '../shared/BackButton';
import MenuWeeklyDetails from './MenuWeeklyDetails';
import MenuCourses from './MenuCourses';
import SVGArchive from '../../svg/Archive';
import SVGTrash from '../../svg/Trash';
import SVGCopy from '../../svg/Copy';

class MenuWeeklyLayout extends React.Component {
  render() {
    const { props } = this;
    const { isEdit, menu } = props;

    return (
      <div className="cms menu">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/menus/weekly" />
            <div className="cms__bar">
              <div className="cms__bar-inputs">
                <HeadingPlaceholder
                  name="name"
                  placeholder="Weekly Menu Name"
                  label="Weekly Menu"
                  isEdit={isEdit}
                  onChange={e =>
                    this.props.updateMenu({ [e.target.name]: e.target.value })
                  }
                  value={menu.name}
                  required
                />
              </div>
              {this.renderCTAs()}
            </div>
          </div>
        </div>

        <div className="cms__body">
          <MenuWeeklyDetails {...props} />
          <MenuCourses {...props} />
        </div>
      </div>
    );
  }

  renderCTAs() {
    const {
      isEdit,
      toggleEdit,
      menu,
      openModal,
      submitPublish,
      submitSaveDraft
    } = this.props;
    const isExisting = 'id' in menu && menu.id > 0;
    // const isDraft = 'status' in menu && menu.status === 'drafted';
    const isPublished =
      'status' in menu && (menu.status === 'live' || menu.status === 'queued');

    // live - delete, duplicate, unpublish?, update
    // queued - delete, duplicate, unpublish?, update

    // draft - delete, duplicate, publish, update
    // past - delete, duplicate

    return (
      <div className="cms__bar-ctas">
        {isExisting ? (
          <div className="btn-icon btn-icon--trash" onClick={() => openModal('delete')}>
            <SVGTrash />
          </div>
        ) : (
          ''
        )}
        {isExisting ? (
          <div className="text-warning" style={{position: 'relative', top: '2px'}} onClick={() => openModal('archive')}>
            <SVGArchive />
          </div>
        ) : (
          ''
        )}
        {isExisting ? (
          <div className="btn-icon btn-icon--copy" onClick={() => openModal('duplicate')}>
            <SVGCopy />
          </div>
        ) : (
          ''
        )}

        <div className="btn btn--hollow-blue" onClick={toggleEdit}>
          {isEdit ? 'Preview' : 'Edit'}
        </div>
        <div className="btn btn--hollow-blue" onClick={() => submitSaveDraft()}>
          {isPublished ? 'Unpublish' : isExisting ? 'Update' : 'Save As Draft'}
        </div>
        <div className="btn btn--solid-blue" onClick={() => submitPublish()}>
          {!isPublished ? 'Publish' : isExisting ? 'Update' : 'Publish'}
        </div>
        {/* Add to Queue - if more than 4 weeks out */}
      </div>
    );
  }
}

export default MenuWeeklyLayout;



// WEBPACK FOOTER //
// ./src/components/menu/MenuWeeklyLayout.js